import { useSelector } from "react-redux";
import { RootState } from "@features/store/store";

const useIsMood = () => {
    return useSelector((state: RootState) => state.header.isMood);
};
const useCurrentTheme = () => {
    return useSelector((state: RootState) => state.header.themeMode);
};

const useClickedRowKey = () => useSelector((state: RootState) => state.header.clickedRowKey);
const useFilterCountries = () => useSelector((state: RootState) => state.header.filterCountries);
const useRegions = () => useSelector((state: RootState) => state.header.regions);

const useGenders = () => useSelector((state: RootState) => state.header.genders);
const useResidenceRegions = () => useSelector((state: RootState) => state.header.residenceRegions);

const useLastGlobalSearchQuery = () => useSelector((state: RootState) => state.header.lastGlobalSearchQuery);

const useDocumentsType = () => useSelector((state: RootState) => state.header.documentsType);

export {
    useIsMood,
    useClickedRowKey,
    useFilterCountries,
    useRegions,
    useGenders,
    useResidenceRegions,
    useCurrentTheme,
    useLastGlobalSearchQuery,
    useDocumentsType,
};
